/**
 * 개인정보처리방침·계정 삭제 요청 링크 — 앱 안에서 쉽게 찾을 수 있어야 한다(애플 심사지침 5.1.1(i), 2026-10-14).
 * 방침 원문은 홈페이지(garameng.kr/gasm/privacy.html)가 정본이고, 삭제 절차는 그 문서 5-1절(#deletion)이다.
 * 앱(Capacitor)에서는 target=_blank 링크가 Safari 로 열린다.
 */
export const PRIVACY_URL = "https://garameng.kr/gasm/privacy.html";
export const ACCOUNT_DELETION_URL = `${PRIVACY_URL}#deletion`;
